'use client'

import React, { memo } from 'react'
import { useNews } from '@/hooks/useNews'
import FeatureTabCard from '../Cards/FeatureTabCard'

interface FeatureTabContentProps {
  slug: string
}

const FeatureTabContent: React.FC<FeatureTabContentProps> = ({ slug }) => {
  const { allNews, isLoading } = useNews({ size: 10, menuSlug: slug })

  if (isLoading) {
    // Skeleton loading
    return (
      <div className="animate-pulse space-y-4 overflow-y-auto max-h-[1090px]">
        {/* Skeleton for each TabCard */}
        {Array.from({ length: 5 }).map((_, index) => (
          <div key={index} className="flex flex-col bg-gray-300 h-[200px] animate-pulse"></div>
        ))}
      </div>
    )
  }

  if (!allNews.length) {
    return <div>No news available</div>
  }

  return (
    <div className="space-y-4">
      {allNews.map((news) => (
        <div key={news.id} className="flex flex-col space-y-4">
          {/* Render TabCard for each news item */}
          <FeatureTabCard
            imageUrl={news.imageUrl}
            title={news.title}
            link={news.slug}
            categoryId={news.categoryId}
            categoryName={news.categoryName}
          />
        </div>
      ))}
    </div>
  )
}

export default memo(FeatureTabContent)
